<ngx-ui-loader></ngx-ui-loader>

<app-toast aria-live="polite" aria-atomic="true"></app-toast>

<div class="user-info-trigger" *ngIf="isLoggedIn" (click)="openUserDetailsModal()">
  <i class="fa fa-user-circle"></i>
</div>

<router-outlet></router-outlet>